import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=43b51300&lang=pug&"
import script from "./NotesView.vue?vue&type=script&lang=js&"
export * from "./NotesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports